var _path, _path2, _path3, _ellipse;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgImportantIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 28,
    viewBox: "0 0 24 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 5C12.7294 5 13.4009 5.39707 13.7524 6.03616L23.7524 24.218C24.0932 24.8376 24.0815 25.5911 23.7216 26.1997C23.3617 26.8084 22.7071 27.1818 22 27.1818H2C1.29288 27.1818 0.638317 26.8084 0.27842 26.1997C-0.0814762 25.5911 -0.0932064 24.8376 0.247568 24.218L10.2476 6.03616C10.5991 5.39707 11.2706 5 12 5ZM3.1 23.1818L2 25.1818H4.28254H19.7175H22L20.9 23.1818L13.1413 9.07504L12 7L10.8587 9.07504L3.1 23.1818Z",
    fill: "#BF152C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2 25.1818L12 7L22 25.1818H2Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.6 19.4375C12.7334 17.8625 13.0667 13.4656 13.0667 12.2188V11.5625H11.0667V12.2188C11.0667 13.4656 11.3334 17.8625 11.5334 19.4375H12.6Z",
    fill: "#BF152C"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 12,
    cy: 22.0625,
    rx: 1.33333,
    ry: 1.3125,
    fill: "#BF152C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImportantIcon);
export default __webpack_public_path__ + "static/media/important-icon.c8277d2e69ab27d55e36580ba8f49f15.svg";
export { ForwardRef as ReactComponent };